import { render, staticRenderFns } from "./StartPortal.vue?vue&type=template&id=bebc6a18"
import script from "./StartPortal.vue?vue&type=script&lang=js"
export * from "./StartPortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports